import { Injectable } from '@angular/core';;
import { cloneDeep } from 'lodash';
import { concat } from 'core-js/fn/array';
import { ClientService } from 'app/customers/client-service/client-service';
import { EchoService } from '../shared/service/echo/echo.service';
import { LoggerService } from '../shared/service/logger/logger.service';
import { combineNames } from 'app/util';

@Injectable({
  providedIn: 'root'
})
export class DirectoryEditService {

  contact_clone:any;
  nameFileds = ['name', 'lastname', 'middlename'];
  addressFields = ['address1','city','county','state','country','zip'];
  updatedFields: any = [];
  dynamicFields: any = [];
  selectedAccount:any;

  constructor(
    private clientService: ClientService,
    private echo: EchoService,
    private logger: LoggerService,

  ) { }

  editContact(key = undefined, value = undefined, editContact = undefined, custom = false, customControl = undefined, dispositionChanged= [], callback) {
      this.updatedFields = [];
      const _id = editContact._id;
      this.contact_clone = cloneDeep({_id: _id});
      this.selectedAccount = null;
      
      if(!custom) {
        if(this.nameFileds.includes(key) || key === 'firstname') {
          this.contact_clone[key] = value;
          this.onNameUpdate(key, value, this.contact_clone);
        }
        else if(this.addressFields.includes(key) || key === 'address') {
          this.onAddressUpdate(key, value, this.contact_clone);
        }
        else if(key === 'dob' || key === 'xDate') {
          this.onDateSelect(key,value);
        }
        else if(key === 'account_name') {
          this.onSelectAccount(value, customControl);
        }
        else if(key === 'agent') {
          this.contact_clone[key] = value;
        }
        else {
          this.contact_clone[key] = value;
        }
        this.validate(value, key, this.contact_clone, false);
      }
      else if(custom) {
        if(this.contact_clone.user_defined_fields && !this.contact_clone.user_defined_fields.length) this.contact_clone.user_defined_fields[0] = {};
        this.contact_clone.user_defined_fields[0][customControl] = value;
      }

      if(key === 'account_name' && this.selectedAccount) {
          let data = this.selectedAccount;
          this.clientService.updateAccountProfile(data).subscribe((res: any) => {
            this.contact_clone.account_id = res;
            this.contact_clone.account_name = this.selectedAccount.account_name;
            if(dispositionChanged && dispositionChanged.length){
              this.contact_clone.dispositionChanged = dispositionChanged;
            }
            else {
             delete this.contact_clone.dispositionChanged    
            }
            this.updateContact(this.contact_clone, (contactInfo)=>{      
              this.logger.log('updateContact afterContactUpdate' ,contactInfo);
              callback(contactInfo);
            });
          },
          err => {
            this.echo.httpErr();
            return;
          });
      }
      else {
        if(dispositionChanged && dispositionChanged.length){
          this.contact_clone.dispositionChanged = dispositionChanged;
        }
        else {
         delete this.contact_clone.dispositionChanged    
        }
        this.updateContact(this.contact_clone, (contactInfo)=>{      
          this.logger.log('updateContact afterContactUpdate' ,contactInfo);
          callback(contactInfo);
        });
      }
  }

  //On change firsname update first, middle, last name and vice versa
  onNameUpdate(key, value, contact_clone) {
      if (contact_clone.firstname && contact_clone.firstname.trim() != '') {
        // this.errMsg = '';
        // this.hasErr = false;
      }
      if(key === 'firstname') {
        if (contact_clone.firstname && contact_clone.firstname.trim().indexOf(" ") != -1) {
          const arr = contact_clone.firstname.trim().split(" ");
          let full = arr;
          const first = full.shift();
          const last = full.pop();
          contact_clone.name = first ? first.toString() : '';
          contact_clone.middlename = (full && full.length) ? full.toString().replace(/,/g, ' ') : '';
          contact_clone.lastname = last ? last.toString() : '';
        }
        else {
          contact_clone.name = contact_clone.firstname;
          contact_clone.middlename = '';
          contact_clone.lastname = '';
        }
      }
      else if(this.nameFileds.includes(key)) {
        contact_clone.firstname =  (contact_clone.name + ' ' + contact_clone.middlename + ' ' + contact_clone.lastname).trim();  
      }
      return;
  }

  //On change address update address sub part and vice versa
  onAddressUpdate(key, value, contact_clone) {
    if (key == 'address') {
      contact_clone.address = value.formatted_address
      contact_clone.address1 = value.address
      contact_clone.city = value.city
      contact_clone.county = value.county
      contact_clone.state = value.state
      contact_clone.country = value.country
      contact_clone.zip = value.zip
      // this.trackFields('address', this.newContact)
    }
    else if(this.addressFields.includes(key)){
      contact_clone[key] = value;
      contact_clone.address = contact_clone.address1 + ", " + contact_clone.city + ", " + contact_clone.state + " " + contact_clone.zip + ", " + contact_clone.country;
    }
  }

  //update account name
  onSelectAccount(account, customControl) {
    this.contact_clone.account_id = this.contact_clone.account_id.map(item=> {
      if(item._id === customControl._id) {
        item.account_name = account;
        this.selectedAccount = item;
      };
      return item;
    });
    return
  }

  //Create log for updated fields
  validate(value, field = undefined, user = undefined, checkErr = true) {
    // check for updated fields
    if (user && user._id) {
      if (field == 'rating') {
        if (value) {
          this.updatedFields.push(field);
        }
      }
      else {
        this.updatedFields.push(field);
      }
    }
  }

  //On date change update format date
  onDateSelect(type, data) {
    this.logger.log("selected date: ", data)
    // this.logger.log("date type: ", type)
    function pad(item) {
      if (item.length == 1) return "0" + item
      return item;
    }
    this.contact_clone[type] = data.year.toString() + "-" + pad(data.month.toString()) + "-" + pad(data.day.toString())
    this.logger.log("onDateSelect: ", this.contact_clone)
    // if (this.contact_clone._id) {
    //   this.updatedFields.push(type)
    // }
  }

  //update the contact
  updateContact(newContact, afterupdate) {
    // this.loading = true
    let payload = cloneDeep(newContact);
    let customField: any;
    if (payload.user_defined_fields) {
      customField = payload.user_defined_fields;
    }
    // if (!payload.userTags) payload.userTags = []
if(payload.userTags){
  payload.userTags = payload.userTags
      .filter(tag => tag)
      .map(item => {
        if (item._id) {
          return item._id
        }
        if (item && !item._id) {
          return item
        }
      })
}
    
    // payload = combineNames(payload);
    this.clientService.updateClientProfile(payload).subscribe((res: any) => {
      // this.added.emit({});
      this.echo.succ("Contact updated")

      // *('constact updated: ', res);
      // this.clientService.setSyncUser(res)
      // this.syncUser(res)

      // emit info for user logs
      let contactInfo = {
        updatedContact: res,
        updatedFields: Array.from(new Set(this.updatedFields)),
        dynamicFields: Array.from(new Set(this.dynamicFields)),
        customFields: customField,
        result: 'success'
      }
      // this.updated.emit(contactInfo);
      // this.loading = false;
      this.logger.log('afterupdate afterContactUpdate' ,contactInfo);
      afterupdate(contactInfo);
    },
    (err)=> {
      this.echo.httpErr();
      let contactInfo = {
        updatedContact: null,
        updatedFields:[],
        dynamicFields: [],
        customFields: null,
        result: 'failed'
      }
      afterupdate(contactInfo);
    })
  }
}
